import { useCurrentLocale } from '../contexts/CurrentLanguageContext'
import { getCurrencyByLocale } from '../model/currency'

export const useCurrency = () => {
	const locale = useCurrentLocale()
	return getCurrencyByLocale(locale)
}
